/**
 * Enum for font styles
 */
export var FontStyle;
(function (FontStyle) {
    FontStyle[FontStyle["None"] = 0] = "None";
    FontStyle[FontStyle["Bold"] = 1] = "Bold";
    FontStyle[FontStyle["Italic"] = 2] = "Italic";
    FontStyle[FontStyle["Underline"] = 4] = "Underline";
    FontStyle[FontStyle["Strikethrough"] = 8] = "Strikethrough";
})(FontStyle || (FontStyle = {}));
/**
 * Enum for annotation resizer location
 */
export var AnnotationResizerLocation;
(function (AnnotationResizerLocation) {
    AnnotationResizerLocation[AnnotationResizerLocation["Corners"] = 1] = "Corners";
    AnnotationResizerLocation[AnnotationResizerLocation["Edges"] = 2] = "Edges";
})(AnnotationResizerLocation || (AnnotationResizerLocation = {}));
/**
 * Enum for cursor type
 */
export var CursorType;
(function (CursorType) {
    CursorType["auto"] = "auto";
    CursorType["crossHair"] = "crosshair";
    CursorType["e_resize"] = "e-resize";
    CursorType["ew_resize"] = "ew-resize";
    CursorType["grab"] = "grab";
    CursorType["grabbing"] = "grabbing";
    CursorType["move"] = "move";
    CursorType["n_resize"] = "n-resize";
    CursorType["ne_resize"] = "ne-resize";
    CursorType["ns_resize"] = "ns-resize";
    CursorType["nw_resize"] = "nw-resize";
    CursorType["pointer"] = "pointer";
    CursorType["s_resize"] = "s-resize";
    CursorType["se_resize"] = "se-resize";
    CursorType["sw_resize"] = "sw-resize";
    CursorType["text"] = "text";
    CursorType["w_resize"] = "w-resize";
})(CursorType || (CursorType = {}));
